import { Card } from '@material-ui/core'
import {
	Typography,
	RadioGroup,
	InputBase,
	Container,
	Toolbar,
	Divider,
	Button,
	AppBar,
	Drawer,
	alpha,
	Menu,
	Grid,
	Box,
    ButtonBase,
} from '@mui/material'
import { styled } from '@mui/styles'

export const HeaderTitle = styled(Box)(() => ({
	textAlign: 'center',
}))

export const Title1 = styled(Typography)(({ theme }) => ({
	fontSize: theme.typography.fontSize,
	color: theme.palette.grey['50'],
	[theme.breakpoints.up('lg')]: {
		fontSize: theme.typography.fontSize * 1.4,
		color: theme.palette.mode === 'dark' ? theme.palette.grey['100'] : '#191B20',
	},
}))
export const Title2 = styled(Typography)(({ theme }) => ({
	fontWeight: theme.typography.fontWeightBold,
	fontSize: theme.typography.fontSize,
	color: theme.palette.grey['100'],
	[theme.breakpoints.up('lg')]: {
		fontSize: theme.typography.fontSize * 1.6,
		color: theme.palette.mode === 'dark' ? theme.palette.grey['50'] : '#0C0D10'
	},
}))

export const HomeWrapper = styled(Box)(({theme}) => ({
    fontFamily: theme.typography.fontFamily,
    marginTop: theme.spacing(-10)
}))

export const NavContainer = styled(Container)(({ theme }) => ({
	maxWidth: theme.breakpoints['lg'],
	minHeight: theme.spacing(6.25),

	[theme.breakpoints.up('lg')]: {
		color: theme.palette.common.black,
		backgroundColor: 'transparent',
		minHeight: theme.spacing(5),
	},

	backgroundColor: theme.palette.tcp.primary.main,
	color: theme.palette.tcp.primary.text,
}))

export const NavToolbar = styled(Toolbar)(({ theme }) => ({
	maxWidth: theme.breakpoints['lg'],
	justifyContent: 'space-between',
	padding: theme.spacing(0.5, 0),
	[theme.breakpoints.up('lg')]: {
		padding: theme.spacing(1, 0),
		justifyContent: 'center',
	},
	minHeight: theme.spacing(4),
	columnGap: theme.spacing(1),
	textAlign: 'center',
}))

export const StyledDrawer = styled(Drawer)(({ theme }) => ({
	'& .MuiDrawer-paper': {
		backgroundColor: theme.palette.tcp.primary.main,
		boxSizing: 'border-box',
		overflow: 'hidden',
		'& .subMenu': {
			backgroundColor: alpha(theme.palette.common.black, 0.1),
			paddingInline: theme.spacing(2),

			'& .MuiButton-root': {
				display: 'block',
				textAlign: 'left',
				width: '100%',
			}
		},
		'& .MuiButton-root': {
			paddingInline: theme.spacing(2),
			justifyContent: 'space-between',
			lineHeight: theme.spacing(5),
			borderRadius: 0,
			'&.MuiButton-contained, &.MuiButton-outlined': {
				paddingInline: theme.spacing(3),
			},
			'&.MuiButton-outlined': {
				borderColor: alpha(theme.palette.common.black, 0.1),
			}
		},
		'& .MuiDivider-vertical': {
			height: '1px !important',
			display: 'block',
			width: '100%',
		},
	}
}))
export const MenuItem = styled(Button)(({ theme }) => ({
	borderRadius: theme.shape.borderRadius * 0.5,
	color: theme.palette.primary.contrastText,
	paddingBlock: theme.spacing(0.25),
}))


export const StyledDivider = styled(Divider)(({ theme }) => ({
	height: theme.spacing(3.25) + ' !important',
	color: theme.palette.grey['50'],
	alignSelf: 'center',
}))

export const StyledMenu = styled(Menu)(({ theme }) => ({
	'& .MuiMenu-paper': {
		backgroundColor: theme.palette.tcp.primary.main,
		borderRadius: theme.shape.borderRadius * .75,
		translateY: theme.spacing(0.5),
		minWidth: 140,

		'& .MuiButton-root': {
			paddingInline: theme.spacing(2),
			textAlign: 'left',
			display: 'block',
			width: '100%',
		}
	}
}))
//TopBar, make it dynamic
export const TCPTopBarWrapper = styled(Box)(({ theme }) => ({
	backgroundColor: theme.palette.tcp.primary.main,
	[theme.breakpoints.up('lg')]: {
		backgroundColor: theme.palette.background.paper,
	},
	padding: theme.spacing(0.25, 0),
}))

export const ContainerWrapper = styled(Container)(({ theme }) => ({
	maxWidth: theme.breakpoints['lg'],
	justifyContent: 'flex-end',
	gap: theme.spacing(2.5),
	alignItems: 'center',
	display: 'flex',
	flexDirection: 'column',
	[theme.breakpoints.up('lg')]: {
		flexDirection: 'row',
	}
}))

//Hero Wrapper

export const HeroWrapper = styled(Box)(({ theme, bgimg }) => ({
	background: `${theme.palette.grey['200']} url('${bgimg}') center center / cover no-repeat`,
	transition: `background 1.5s ease-in-out`,
	minHeight: `calc(100dvh + 350px)`,
	position: 'relative',

	[theme.breakpoints.up('lg')]: {
		minHeight: `calc(100dvh + 400px)`,
	}
}))
export const HeroTopLeftMessage = styled(Box)(({ theme }) => ({
	backgroundColor: alpha(theme.palette.common.black, 0.25),
	fontWeight: theme.typography.fontWeightMedium,
	textShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.75)',
	inset: theme.spacing(4, 4, 'auto', 4),
	[theme.breakpoints.up('sm')]: {
		inset: theme.spacing(4, 'auto', 'auto', 4),
	},
	fontSize: theme.typography.fontSize * 1.4,
	color: theme.palette.common.white,
	borderRadius: theme.spacing(0.5),
	backdropFilter: 'blur(1px)',
	padding: theme.spacing(2),
	position: 'absolute',
}))

export const HeroMantriStrip = styled(Box)(({ theme }) => ({
	backgroundColor: alpha(theme.palette.common.black, 0.7),
	inset: theme.spacing('auto', 0, 2),
	color: theme.palette.common.white,
	padding: theme.spacing(3, 4),
	[theme.breakpoints.up('md')]: {
		padding: theme.spacing(3, 8),
	},
	[theme.breakpoints.up('lg')]: {
		padding: theme.spacing(3, 12), //??
	},
	backdropFilter: 'blur(1px)',
	position: 'absolute',
}))

export const PersonCard = styled(Grid)(({ theme }) => ({
	justifyContent: 'space-between',
	gap: theme.spacing(2),
	alignItems: 'center',
	display: 'flex',
}))
export const PersonPic = styled(Box)(({ theme }) => ({
	'& img': {
		objectFit: 'cover',
		display: 'block',
		height: 80,
		width: 80,
	}
}))

export const PersonDesc = styled(Box)(({ theme }) => ({
	fontSize: theme.typography.fontSize,
	color: theme.palette.common.white,
	flex: 1,

	'& strong': {
		fontWeight: theme.typography.fontWeightMedium,
		display: 'block',
	},
}))

///// Services
export const ServicesContainer = styled(Container)(({ theme }) => ({
	maxWidth: theme.breakpoints['lg'],
	paddingBlock: theme.spacing(4),
}))

export const ServiceGrid = styled(Grid)(({ theme }) => ({
	justifyContent: 'center',

	'& .MuiButtonBase-root': {
		fontWeight: theme.typography.fontWeightSemiBold,
		flexDirection: 'row',
		textAlign: 'center',
		width: '100%',
		flex: 1,

		'& img': {
			marginBottom: theme.spacing(1),
			display: 'block',
			margin: 'auto',
			maxWidth: 150,
		}
	}
}))

const getGradientBackground = (index) => {
    switch (index) {
      case 0:
        return 'linear-gradient(to bottom, #F7A143, #fbdfb3)';
      case 1:
        return 'linear-gradient(to bottom, #4BAB58, #b7ddbc)';
      case 2:
        return 'linear-gradient(to bottom, #60329C, #bfadd7)';
      case 3:
        return 'linear-gradient(to bottom, #2E91E8, #abd3f5)';
      default:
        return 'linear-gradient(to bottom, #000000, #FFFFFF)'; // Default gradient
    }
  };

export const ServiceButton = styled(ButtonBase)(({theme, index}) => ({
    padding: theme.spacing(2), 
    backgroundImage: getGradientBackground(index),
    borderRadius: '20px', 
    color: 'white',
    textAlign: 'center',
    width: '100%',
    height: '100%',
}))

// Facilation
const Image = 'https://i.imgur.com/4LnPljT.jpeg';
export const FacilationContainer = styled(Card)(({ theme }) => ({
	position: 'relative',
    width: '100%',
    margin: 'auto',
    marginTop: theme.spacing(4),
    padding: theme.spacing(2),
    height: 'auto',
    overflow: 'hidden',
}))

export const CitizenTextContainer = styled('div')(({theme}) => ({
	margin: 'auto',
	textAlign: 'center',
	color: '#fff',
	fontWeight: 'bold',
	marginTop: theme.spacing(2),
	fontSize: '24px'
}))

export const FacilationButton = styled(ButtonBase)(({theme}) => ({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
    textAlign: 'center',
    width: '100%',
    height: '100%',
}))